module.exports = "<h2 id=jpex-use>Jpex.use</h2> <p><code>Function(plugin, [options])</code><br>Installs a plugin onto the current class - usually the root Jpex object.</p> <pre><code class=lang-javascript>Jpex.use(plugin);\n</code></pre> ";


//////////////////
// WEBPACK FOOTER
// ./src/content/api/use.md
// module id = 42
// module chunks = 0